module.exports = __webpack_public_path__ + "assets/img/email-6307d444.png";